import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { AverageReportType, GroupType, HighlightedProps, SchoolReportType } from '../../types';
import { SectionLayout } from '../modules';
import type { ChartIconType } from '../../../components/charts/types';
import { StudentProgress } from '../../../components';
import * as d3 from 'd3';

type Props = {
  schoolReport: SchoolReportType
  showOthersData: boolean
  iconToUse: ChartIconType
} & HighlightedProps;

const MathsAgeDelta = ({ schoolReport, showOthersData, iconToUse, highlightedLabel, highlightedIds, onElementClick }: Props): JSX.Element => {
  const { translate } = useI18n();
  const avgMathsAgeDelta = (schoolReport.average.mathsAgeAverage ? (schoolReport.average.mathsAgeAverage - schoolReport.average.actualAgeAverage) : 0).toFixed(2);

  const dataToUse = (): (GroupType & AverageReportType)[] => {
    if (iconToUse === 'class') {
      return schoolReport.classes;
    } else return schoolReport.yearGroups;
  };

  const getHighlightedValue = (): string | null => {
    if (highlightedIds && highlightedIds.length > 0) {
      const mean = d3.mean(dataToUse().map((cl) => {
        if (highlightedIds.includes(cl.id)) {
          return cl.chartsData?.mathsAgeDelta;
        }
      }));
      return mean != undefined ? mean.toFixed(2) : null;
    }

    return null;
  };

  return (
    <SectionLayout
      title={translate('pages.SCHOOL_REPORTS.SECTIONS.MATHS_AGE_DELTA.title')}
      value={showOthersData ? avgMathsAgeDelta : null}
      highlightLabel={highlightedLabel}
      highlightValue={getHighlightedValue()}
      unit={translate('pages.SCHOOL_REPORTS.SECTIONS.MATHS_AGE_DELTA.unit', { count: parseFloat(avgMathsAgeDelta) })}
      moreInfo={translate('pages.SCHOOL_REPORTS.SECTIONS.MATHS_AGE_DELTA.info')}
      id={'maths-age-delta-container'}
    >
      <div>
        <StudentProgress
          showOthersData={showOthersData}
          data={dataToUse()}
          chartType={'mathsAgeDelta'}
          type={iconToUse}
          highlightedIds={highlightedIds}
          thinAxis
          onElementClick={onElementClick}
        />
      </div>
    </SectionLayout>
  );
};

MathsAgeDelta.displayName = 'MathsAgeDelta';

export default MathsAgeDelta;
